/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types'
import {
  largeCardStyle,
  largeCardStyleSelected,
  largeCardThumbnailStyle,
  largeCardContentStyle,
  largeCardTitleStyle,
  largeCardLabelStyle,
  playingIndicatorStyle,
} from '../styles'

/**
 * RecapCard component for displaying the game recap highlight
 * @param {Object} props - Component props
 * @param {Object} props.recap - Recap data
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.isPlaying - Whether this card's video is currently playing
 * @returns {JSX.Element} RecapCard component
 */
const RecapCard = ({ recap, onClick, isPlaying }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(recap)
    }
  }

  return (
    <div
      css={isPlaying ? largeCardStyleSelected : largeCardStyle}
      onClick={handleClick}
    >
      <img src={recap.thumb} alt={recap.title} css={largeCardThumbnailStyle} />
      <div css={largeCardContentStyle}>
        <div css={largeCardTitleStyle}>{recap.title}</div>
        <div css={largeCardLabelStyle}>{recap.label}</div>
      </div>
      {isPlaying && <div css={playingIndicatorStyle} />}
    </div>
  )
}

RecapCard.propTypes = {
  recap: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
}

RecapCard.defaultProps = {
  onClick: null,
  isPlaying: false,
}

export default RecapCard
